import { useTheme } from '@mui/material/styles';

const useNavColors = () => {
    const theme = useTheme();

    return {
        background: theme.palette.devblue[100],
        text: theme.palette.white[100],
        icon: theme.palette.white[100],
        iconActiveColor: theme.palette.white[100],
        linkIconColor: theme.palette.devblue[60],
        linkIconActiveColor: theme.palette.white[100],
        linkColor: theme.palette.white[100],
        linkHoverColor: theme.palette.white[100],
        linkHoverBgColor: theme.palette.devblue[90],
        linkActiveColor: theme.palette.white[100],
        linkActiveBgColor: theme.palette.devblue[90],
        borderColor: theme.palette.devblue[95],
    };
};

export default useNavColors;
